import { Controller } from "@hotwired/stimulus"

// Mirrors Property#submission_blockers on the client so the "Submit for
// Review" button is only enabled when the listing meets the minimum bar.
// Server-side enforcement in PropertiesController#create remains the
// authoritative gate; this is purely UX guidance.
export default class extends Controller {
  static values = { minDescription: Number, hasExistingPhotos: Boolean }
  static targets = ["submitButton"]

  connect() {
    // Re-evaluate on any input/change inside the form (events bubble up).
    this.evaluate = this.evaluate.bind(this)
    this.element.addEventListener("input", this.evaluate)
    this.element.addEventListener("change", this.evaluate)
    this.evaluate()
  }

  disconnect() {
    this.element.removeEventListener("input", this.evaluate)
    this.element.removeEventListener("change", this.evaluate)
  }

  evaluate() {
    const checks = {
      description: this.#descriptionLong(),
      location: this.#locationFilled(),
      activity: this.#hasAnyChecked('input[name="property[activity_ids][]"]'),
      photos: this.hasExistingPhotosValue || this.#hasFiles("property_images"),
      price: this.#numberAbove("property_base_price_per_day", 0),
      occupancy: this.#numberAtLeast("property_max_occupancy", 1)
    }

    let allOk = true
    this.element.querySelectorAll(".submission-check").forEach((row) => {
      const ok = checks[row.dataset.requirement] === true
      if (!ok) allOk = false
      const icon = row.querySelector(".check-icon")
      icon.classList.toggle("fa-regular", !ok)
      icon.classList.toggle("fa-circle", !ok)
      icon.classList.toggle("text-muted", !ok)
      icon.classList.toggle("fas", ok)
      icon.classList.toggle("fa-circle-check", ok)
      icon.classList.toggle("text-success", ok)
    })

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = !allOk
      this.submitButtonTarget.title = allOk
        ? ""
        : "Complete the checklist above before submitting for review."
    }
  }

  // --- private ---

  #descriptionLong() {
    const value = (document.getElementById("property_description")?.value || "").trim()
    return value.length >= this.minDescriptionValue
  }

  #locationFilled() {
    return Boolean(document.getElementById("property_city")?.value.trim()) &&
           Boolean(document.getElementById("property_state")?.value.trim())
  }

  #hasAnyChecked(selector) {
    return Array.from(document.querySelectorAll(selector)).some((el) => el.checked)
  }

  #hasFiles(id) {
    const input = document.getElementById(id)
    return Boolean(input?.files?.length)
  }

  #numberAbove(id, min) {
    const value = parseFloat(document.getElementById(id)?.value)
    return Number.isFinite(value) && value > min
  }

  #numberAtLeast(id, min) {
    const value = parseInt(document.getElementById(id)?.value, 10)
    return Number.isFinite(value) && value >= min
  }
}
